<template>
    <div class="fieldset">
        <text-headline-secondary>
            {{ title }}
        </text-headline-secondary>

        <p>
            {{ description }} -
            <a class="readmore" href="#" @click.prevent="$emit('linkClick')">
                {{ link }}
            </a>
        </p>

        <div class="row">
            <div class="field">
                <field-customer-identification :validate="validate" />
            </div>
            <div class="field">
                <field-customer-control-numbers :validate="validate" />
            </div>
        </div>
    </div>
</template>

<script>
import FieldCustomerIdentification from "@/components/fields/FieldCustomerIdentification";
import FieldCustomerControlNumbers from "@/components/fields/FieldCustomerControlNumbers";

export default {
    name: "FieldsetCustomerIdentification",
    components: {
        FieldCustomerIdentification,
        FieldCustomerControlNumbers
    },
    props: {
        validate: { type: Boolean, default: false },
        title: { type: String, required: true },
        description: { type: String, required: true },
        link: { type: String, required: true }
    }
};
</script>

<style scoped lang="scss">
.field {
    margin-bottom: 1rem;
}

@media (min-width: $breakpoint-tablet) {
    .row {
        display: flex;
    }

    .field {
        margin-bottom: 1.5rem;
    }

    .row .field {
        flex: 1 1 0px;
    }

    .row .field + .field {
        margin-left: 1.5rem;
    }
}
</style>
